import {ImgHTMLAttributes, useContext} from 'react'

import {Context} from '../../Header/Context'

type ImageComponentProps = ImgHTMLAttributes<HTMLImageElement> | any

export function ImageComponent(props: ImageComponentProps) {
  const {ImageComponent} = useContext(Context)

  return ImageComponent ? <ImageComponent {...props} /> : <img {...props} />
}
